export const SHOW_TOAST = 'SHOW_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';
export const SHOW_AND_REMOVE = 'SHOW_AND_REMOVE';
export const SET_CONTAINER_HOVER = 'SET_CONTAINER_HOVER';